module.exports = __webpack_public_path__ + "static/img/page60.b9f1f3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page60.png
// module id = 1Dnx
// module chunks = 0